import React, { useContext, useEffect, useRef } from "react";
import { useAuthStore } from "../@shared/store/useAuthStore";
import Dashboard from "./Dashboard";
import Landing from "../components/HomeScreen/Landing";
import { Grid } from "@mui/material";
import { MainContext } from "../App";
import TutorialSequences from "./TutorialSequences";
import Toast from "../components/Toast";
import { ensureInitialSignupRewards } from "../@shared/utils/signupRewards";

const HomeScreen = ({ isAuth }) => {
  const { gameScreenLoading, setGameScreenLoading } =
    useContext(MainContext);
  const { userData } = useAuthStore();

  const hasIssuedRewardsRef = useRef(false);

  useEffect(() => {
    if (!userData?.id) {
      hasIssuedRewardsRef.current = false;
      return undefined;
    }

    if (hasIssuedRewardsRef.current) {
      return undefined;
    }

    hasIssuedRewardsRef.current = true;
    ensureInitialSignupRewards(userData.id).catch((error) => {
      console.error("Error in ensureInitialSignupRewards:", error);
    });

    return undefined;
  }, [userData?.id]);

  useEffect(() => {
    if (gameScreenLoading && userData) {
      setTimeout(() => {
        setGameScreenLoading(false);
      }, 3500);
    }
  }, [userData, gameScreenLoading, setGameScreenLoading]);

  return (
    <Grid container xs={12} style={{ height: "100%" }}>
      <Toast onFinish={() => {}} timeTilClose={3000} />
      {userData?.username ? (
        !userData.completedTutorial ? (
          <TutorialSequences />
        ) : (
          <Dashboard />
        )
      ) : (
        <Landing isAuth={isAuth} />
      )}
    </Grid>
  );
};

export default HomeScreen;
